'use strict';

import $ from 'jquery';
require('./setup');
// import 'jquery-ui/ui/widgets/autocomplete';
